import { render, staticRenderFns } from "./SchoolView.vue?vue&type=template&id=675612b9&scoped=true"
import script from "./SchoolView.vue?vue&type=script&lang=js"
export * from "./SchoolView.vue?vue&type=script&lang=js"
import style0 from "./SchoolView.vue?vue&type=style&index=0&id=675612b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675612b9",
  null
  
)

export default component.exports